(function ($) {
  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this;
      var args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  $(".contact_me").each(function (i, el) {
    var mail = $(el).attr("data-val") || false;
    if (!mail || mail.indexOf("§%§") === -1 || mail.indexOf("%§%") === -1) {
      $(el).attr("data-val", "");
      return;
    }
    mail = mail.replace(/\@/g, "o").replace(/%§%/g, "@").replace(/§%§/g, ".");
    var text = $(el).html().trim();

    var link = $("<a>", {
      href: "mailto:" + mail,
      rel: "nofollow",
      class: ($(el).attr('class') || "").replace('contact_me', ''),
    });
    link.html(!text ? mail : text);
    $(el).replaceWith(link);
  });


  $("html").removeClass("no-js").addClass("js");

  $(window).resize(
    debounce(function (e) {
      genScrollMenu();
      if ($('.bg-img').length) {
        window.setTimeout(function () {
          $('.bg-img').each(function(index, el) {
            resizeImage($(el));
          });
        }, 0);
      }
      if ($('.vert-img').length) {
        window.setTimeout(function () {
          $('.vert-img').each(function(index, el) {
            vertImage($(el));
          });
        }, 0);
      }
    }, 400)
  );


  function smoothScroll(e, direct) {
    var target;
    if (typeof direct === "undefined" || !direct) {
      target = this.hash || window.location.hash;
      target = !target ? $(e.target).closest("a").attr("href") : target;
    } else {
      target = e;
    }

    var $target = $(target).length ? $(target) : $("[name='" + window.location.hash.substr(1) + "']");

    // console.log($target);

    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: $target.offset().top - $('.site-header').outerHeight(true),
        },
        400,
        "linear"
        // function() {
        //   window.location.hash = target;
        // }
      );
        if (!!window.history) {
            history.pushState({}, window.title, '#' + $target.attr('id'));
        }
    return false;
  }

    if (!!window.location.hash) {
        smoothScroll(window.location.hash, 1);
    }

    $('.wp-block-bpm-block-btn', '.page-id-269').on('click', function(e) {
        e.preventDefault();
        return smoothScroll("#" + $(e.target).closest('a').attr('href').split("#").pop(), 1);
    });


  // scrollto hash
  $(".scrollTo").on("click", function (e) {
    e.preventDefault();
    smoothScroll(e);
    return false;
  });


  // scrollto navlinks
  $(".nav-link", "#main-primary-menu").on("click", function (e) {
    var href = $(e.target).closest("a").attr("href");
    if (href.indexOf("#") + 1 < 1 || window.location.pathname !== "/") return;
    smoothScroll("#" + href.split("#").pop(), 1);
    $(e.target)
      .closest("ul")
      .find("li.active")
      .removeClass("current-menu-item active current-menu-item current_page_item");
    $(e.target).closest("ul").find("a").removeClass("current-menu-item current_page_item");
    $(e.target)
      .closest("li")
      .addClass("current-menu-item active")
      .find("a")
      .addClass("current-menu-item current_page_item");
    return false;
  });


  // navlink active link onload
  $(window).on("load", function (e) {
    if (window.location.pathname !== "/") return;
    $("#main-primary-menu")
      .find("li.active")
      .removeClass("current-menu-item active current-menu-item current_page_item");
    $("#main-primary-menu").find("a").removeClass("current-menu-item current_page_item");
    $("li:first-of-type", "#main-primary-menu")
      .addClass("current-menu-item active")
      .find("a")
      .addClass("current-menu-item current_page_item");
    return false;
  });



  // carousel img repair & touch
  function resizeImage($img) {
    $img.removeClass("resizeVertical");
    if ($img.width() < $img.parent().width() && $img.width() > 0 && $img.height() >= $img.parent().height()) {
      $img.addClass("resizeVertical");
    }
  }
  function vertImage($img) {
    $img.removeClass("resizeVertical");
    if ($img.height() < $img.parent().height() && $img.width() >= $img.parent().width() && $img.width() > 0) {
      $img.addClass("resizeVertical");
    }
  }

  $('img').on('load', function(e) {
    if ($(e.target).hasClass('bg-img')) {
      resizeImage($(e.target));
    }
    if ($(e.target).hasClass('vert-img')) {
      vertImage($(e.target));
    }
  });


  if (!!navigator.userLanguage || !!navigator.browserLanguage || !!navigator.systemLanguage) {
    $("body").addClass("ie11");
    // console.log("ie11");
  }


  //
  var bpmShadowSvg = function (icon, classes) {
    return '<div class="svg-wrapper"><svg fill="currentColor"'
      + (!classes || classes.length ? '' : (' class="' + classes.join(' ') + '"'))
      + '><use href="#' + icon + '"/></svg></div>';
  };

  
  var $window = $(window);
  function reRenderMainNav() {
      var $oMainNav = $('#navbar-main').find('.container'),
          $oNavList = $('#bb4-primary-menu'),
          $oMoreLinks = $oNavList.find('.moreLinks');

      // Abbrechen, wenn Fensterbreite <= 767
      if ($window.width() <= 750) {
          $oMoreLinks.each(function () {
          $(this).addClass('nav-item')
              .find('.dropdown-item')
              .removeClass('dropdown-item')
              .addClass('nav-link');
          });
          $oMoreLinks.before($oMoreLinks.find('> ul > li'));
          $oMoreLinks.remove();
          return;
      }

      if ($oMoreLinks.length) {
          $oMoreLinks.find('> ul > li').each(function () {
              $(this).addClass('nav-item')
                  .find('> .dropdown-item')
                  .removeClass('dropdown-item')
                  .addClass('nav-link');
          });
          $oMoreLinks.before($oMoreLinks.find('> ul > li'));
      } else {
          var oMoreLinkElem = document.createElement('li'),
              oMoreLinkAElem = document.createElement('a'),
              oMoreLinkUlElem = document.createElement('ul');

          oMoreLinkElem.className = 'dropdown dropstart moreLinks menu-item nav-item';

          oMoreLinkAElem.className = 'dropdown-toggle nav-link menu-item d-inline-flex align-items-center';
          oMoreLinkAElem.innerHTML = '&nbsp;<div class="icon">' + bpmShadowSvg('svg-ellipsis-h') + '</div>&nbsp;'; // BPM.txt.more;
          oMoreLinkAElem.setAttribute('data-bs-toggle', 'dropdown');

          oMoreLinkUlElem.className = 'dropdown-menu';
          oMoreLinkUlElem.setAttribute('role', 'menu');

          oMoreLinkElem.appendChild(oMoreLinkAElem);
          oMoreLinkElem.appendChild(oMoreLinkUlElem);

          $oNavList.append(oMoreLinkElem);
          $oMoreLinks = $(oMoreLinkElem);
      }

      var iMainNavWidth = $oMainNav.width()
              - $oMainNav.find('.navbar-brand').outerWidth(true)
              - $oMainNav.find('.ms-auto.me-0').outerWidth(true),
          $oNavItems = $oNavList.find('> li').not('.moreLinks'),
          iNavItemsWidth = 0,
          aMoreLinkElems = [];

      $oNavItems.each(function () {
          var $this = $( this );
          iNavItemsWidth += $this.outerWidth(true);
      });

      if (iNavItemsWidth > iMainNavWidth) {
          iMainNavWidth -= Math.ceil($oMoreLinks.outerWidth(true));
          iNavItemsWidth = 0;
          
          $oNavItems.each( function ()
              {
                  var $this = $( this );
                  iNavItemsWidth += $this.outerWidth(true);
              
                  if (Math.ceil(iNavItemsWidth) > iMainNavWidth) {
                      $this.removeClass('nav-item')
                          .find('> .nav-link')
                          .addClass('dropdown-item')
                          .removeClass('nav-link');
                      if ($this.hasClass('active')) {
                          $this.find('> a').addClass('active');
                      }
                      aMoreLinkElems.push( $this );
                  }
              }
          );
      }

      if (aMoreLinkElems.length) {
          $oMoreLinks.find('> ul').append(aMoreLinkElems);
      } else {
          $oMoreLinks.remove();
      }
  }

  $(function () {
      reRenderMainNav();
  });
  $(window).resize(function() {
      reRenderMainNav();
  });

  //////
    $('.single-gallery').magnificPopup({
        type: 'image',
        gallery:{
        enabled:true
        }
    });

    $('.gallery_enlarge_icon').magnificPopup({
        type: 'image',
        gallery:{
        enabled:true
        }
    });

    $('.widget .wp-block-gallery a').magnificPopup({
        type: 'image',
        gallery:{
        enabled:true
        }
    });


    //// admin bar fix
    if ($('#wpadminbar').length) {
        $('html').attr('style', function(i,s) { return (s || '') + 'margin-top: 0 !important;' });
    }
})(jQuery);
